import { render, staticRenderFns } from "./anchor-link.vue?vue&type=template&id=5467e9c8&"
import script from "./anchor-link.vue?vue&type=script&lang=js&"
export * from "./anchor-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5467e9c8')) {
      api.createRecord('5467e9c8', component.options)
    } else {
      api.reload('5467e9c8', component.options)
    }
    module.hot.accept("./anchor-link.vue?vue&type=template&id=5467e9c8&", function () {
      api.rerender('5467e9c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/anchor/anchor-link.vue"
export default component.exports